/* ============================================================================
   hd-ship.js —— 配送地区（localization）公共件（2026-10-09 建 / 丁批瘦身）
   ----------------------------------------------------------------------------
   2026-10-09 丁批「甲」：公告条那颗「Ship to ××× ▾」胶囊**已删**。
   改地区收敛到**商品详情页**两处入口（配送块国家名 / US-only 提示条），
   都由 assets/pf-delivery.js 的 #pfdlv-pick 简洁浮层承担
   ⇒ 本文件**不再有任何 UI**（原来的面板构建 / 搜索过滤 / 键盘导航 / 点外部守卫全部移除）。

   留下的只有两件事：
     ① ?cc=XX URL 参数快切（自测快捷方式）。
        ⚠️ 2026-10-09 实测修正：Shopify 的 request.path **含 query**（旧注释「只取 path
        不含 query」写反了）⇒ 提交后仍停在 ?cc=XX。靠 set() 里「目标国 == 当前国 ⇒
        不提交」这一条保证**不循环**（第二跳 cur 已是目标国，直接返回 false）。
     ② window.__hdShip.set(cc) —— 一行式切换（控制台 / 自动化用）。

   🔴 真源仍是 Shopify 官方 /localization：本文件不自己存国家、不自己算，
      只把选择结果交给 #hdShipForm 提交，由 Shopify 写 cookie 并整页重载
      ⇒ 顶栏免邮文案 / 购物车进度条 / 商品页预计送达 / US-only 可售性
        四处**一起**跟着变（它们本来就都读同一个源）。

   🔴 数据（#hdShipData）与表单（#hdShipForm）在 layout/theme.liquid，
      消费方是 pf-delivery.js 的 pickCountries() / submitCountry()。
      本文件**只读不写**，避免出现第二份真源。
   ========================================================================== */
(function () {
  'use strict';
  if (window.__hdShip) return;

  var D = document, W = window;
  var form = D.getElementById('hdShipForm');
  var code = D.getElementById('hdShipCode');
  var dataEl = D.getElementById('hdShipData');
  /* 🔴🔴 缺件 ⇒ 直接不导出。注意这里**不能**像旧版那样把 #hdShipBtn / #hdShipPanel
     写进守卫 —— 它们已经删了，多一个恒 null 的判断会让整个 IIFE 早退，
     连 ?cc=XX 快切一起静默失效（本项目最恨的失败形态）。 */
  if (!form || !code || !dataEl) return;

  var all = [];
  try { all = JSON.parse(dataEl.textContent || '[]') || []; } catch (e) { all = []; }
  if (!all.length) return;

  var cur = String(code.value || '').toUpperCase();

  function has(cc) {
    for (var i = 0; i < all.length; i++) { if (all[i].c === cc) return true; }
    return false;
  }

  /* 切到 cc ⇒ 提交并整页刷新。与当前国相同 ⇒ 不刷新（零无谓请求）。 */
  function set(cc) {
    cc = String(cc || '').toUpperCase();
    if (!/^[A-Z]{2}$/.test(cc) || !has(cc) || cc === cur) return false;
    code.value = cc;
    form.submit();
    return true;
  }

  /* ------------------------------------------------- ?cc=XX 自测快捷方式 */
  try {
    var m = /[?&]cc=([A-Za-z]{2})(?:&|$)/.exec(String(W.location.search || ''));
    if (m && set(m[1])) return;      /* 提交即整页重载 ⇒ 后面的语句不会再跑 */
  } catch (e) {}

  W.__hdShip = { countries: all, current: cur, set: set };
})();
